export const mockFeatures = [
  {
    icon: 'ri-smartphone-line',
    title: '下拉式阅读',
    description: '告别翻页烦恼，像刷朋友圈一样流畅地阅读漫画，单手操作轻松自在，通勤路上也能畅快追漫。',
  },
  {
    icon: 'ri-vip-crown-line',
    title: '永久免费全集',
    description: '热门韩漫、日漫、国漫全集完全免费开放，无需付费订阅，无需观看广告，真正零门槛畅读全站作品。',
  },
  {
    icon: 'ri-flashlight-line',
    title: '极速追更',
    description: '新章节上线第一时间推送提醒，与海外平台同步更新，让你永远快人一步，不再错过任何精彩剧情。',
  },
  {
    icon: 'ri-hd-line',
    title: '高清画质',
    description: '全部漫画采用高清扫描与智能优化，画面细腻锐利，色彩忠实还原，为你呈现沉浸式视觉阅读盛宴。',
  },
];

export const mockAbout = {
  title: '关于羞羞漫画',
  content: '羞羞漫画是国内领先的免费漫画在线阅读平台，自上线以来始终坚持"免费、高清、极速"的服务理念，为漫画爱好者打造最优质的在线阅读体验。我们汇聚了来自韩国、日本以及国内顶尖漫画工作室的海量正版授权作品，涵盖恋爱、奇幻、动作、悬疑、搞笑等数十个题材分类，满足不同读者的多元阅读口味。平台采用创新的下拉式阅读模式，摒弃传统翻页的繁琐操作，同时配合强大的内容推荐算法，帮你发现更多喜欢的漫画作品。无论你是韩漫的忠实粉丝，还是日漫的资深爱好者，亦或是国漫的新锐追随者，在羞羞漫画都能找到属于你的那部心头好。',
};

export const mockCarouselItems = [
  {
    title: '2024年度最受欢迎韩漫TOP10',
    description: '从甜蜜恋爱到悬疑惊悚，这份榜单囊括了今年最值得一读的韩漫作品，部部高分，本本精彩。',
    tag: '年度盘点',
    image: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20romance%20drama%20illustration%20style%2C%20soft%20pastel%20colors%2C%20two%20characters%20facing%20each%20other%20with%20dramatic%20lighting%2C%20emotional%20atmosphere%2C%20clean%20composition%20with%20warm%20pink%20and%20peach%20background&width=800&height=500&seq=carousel-kr-01&orientation=landscape',
  },
  {
    title: '日漫经典回归：那些年我们追过的神作',
    description: '经典日漫高清重制版陆续上线，《灌篮高手》《犬夜叉》等不朽名作带你重温热血青春。',
    tag: '经典回顾',
    image: 'https://readdy.ai/api/search-image?query=Japanese%20manga%20classic%20style%20action%20scene%2C%20dynamic%20composition%20with%20motion%20lines%2C%20warm%20nostalgic%20color%20palette%20orange%20and%20amber%20tones%2C%20samurai%20and%20school%20life%20themes%20blended%2C%20clean%20modern%20rendering&width=800&height=500&seq=carousel-jp-02&orientation=landscape',
  },
  {
    title: '国漫崛起：这些原创作品火到海外',
    description: '国漫原创力量蓬勃生长，多部作品出海日韩欧美，用东方美学征服全球读者。',
    tag: '国漫之光',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20original%20art%20style%2C%20fantasy%20martial%20arts%20theme%20with%20flowing%20ink%20brush%20effects%2C%20ethereal%20characters%20in%20traditional%20robes%2C%20golden%20and%20coral%20warm%20color%20scheme%2C%20elegant%20composition&width=800&height=500&seq=carousel-cn-03&orientation=landscape',
  },
  {
    title: '恋爱漫画专区：甜到牙疼的百部精选',
    description: '从校园纯爱到办公室恋情，从青梅竹马到霸道总裁，百部高甜恋爱漫画一次打包。',
    tag: '甜宠推荐',
    image: 'https://readdy.ai/api/search-image?query=Romantic%20manga%20illustration%20with%20cherry%20blossom%20petals%2C%20couple%20silhouette%20under%20soft%20sunset%20light%2C%20warm%20peach%20and%20pink%20gradient%20background%2C%20gentle%20and%20dreamy%20atmosphere%2C%20clean%20aesthetic%20composition&width=800&height=500&seq=carousel-rom-04&orientation=landscape',
  },
];

export const mockIndexItems = [
  { title: '恋爱漫画', icon: 'ri-heart-line', count: '1,286部', color: 'primary' },
  { title: '奇幻冒险', icon: 'ri-compass-3-line', count: '943部', color: 'accent' },
  { title: '悬疑推理', icon: 'ri-search-eye-line', count: '567部', color: 'secondary' },
  { title: '动作热血', icon: 'ri-fire-line', count: '789部', color: 'primary' },
  { title: '搞笑日常', icon: 'ri-emotion-laugh-line', count: '654部', color: 'accent' },
  { title: '古风仙侠', icon: 'ri-moon-line', count: '432部', color: 'secondary' },
  { title: '都市言情', icon: 'ri-building-line', count: '876部', color: 'primary' },
  { title: '恐怖惊悚', icon: 'ri-ghost-line', count: '321部', color: 'accent' },
  { title: 'BL/GL专区', icon: 'ri-hearts-line', count: '543部', color: 'secondary' },
];

export const mockCards = [
  {
    title: '《社内恋爱法则》',
    description: '职场新人林小晚意外与冷酷总裁成为邻居，一场鸡飞狗跳的同居恋爱喜剧就此展开！',
    tag: '韩漫·恋爱',
    status: '连载中',
    heat: '9.7',
    image: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20office%20romance%20illustration%2C%20professional%20couple%20in%20modern%20office%20setting%2C%20warm%20peach%20and%20cream%20color%20palette%2C%20clean%20minimalist%20background%2C%20soft%20lighting%2C%20elegant%20fashion&width=400&height=560&seq=card-office-01&orientation=portrait',
  },
  {
    title: '《剑道至尊》',
    description: '废柴少年偶获上古剑灵传承，从此踏上逆天改命的修仙之路，一剑斩破九重天！',
    tag: '国漫·仙侠',
    status: '连载中',
    heat: '9.5',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20martial%20arts%20fantasy%20character%20with%20sword%2C%20flowing%20robes%20in%20wind%2C%20dramatic%20golden%20light%20effect%2C%20ancient%20Chinese%20aesthetic%2C%20warm%20amber%20and%20coral%20tones%2C%20epic%20atmosphere&width=400&height=560&seq=card-sword-02&orientation=portrait',
  },
  {
    title: '《第七个夜晚》',
    description: '连续七夜的诡异梦境，现实与虚幻的边界逐渐模糊，凶手可能就在身边……',
    tag: '日漫·悬疑',
    status: '已完结',
    heat: '9.8',
    image: 'https://readdy.ai/api/search-image?query=Japanese%20manga%20mystery%20thriller%20style%2C%20dark%20alley%20with%20single%20figure%20silhouette%2C%20atmospheric%20noir%20lighting%2C%20deep%20shadows%20with%20warm%20streetlamp%20glow%2C%20suspenseful%20mood%2C%20clean%20composition&width=400&height=560&seq=card-mystery-03&orientation=portrait',
  },
  {
    title: '《甜蜜陷阱》',
    description: '表面温柔体贴的完美男友，背后却藏着惊人秘密，她该如何逃离这场精心设计的爱情骗局？',
    tag: '韩漫·剧情',
    status: '连载中',
    heat: '9.4',
    image: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20drama%20romance%20couple%20with%20intense%20eye%20contact%2C%20elegant%20cafe%20background%2C%20warm%20golden%20hour%20lighting%2C%20emotional%20tension%2C%20soft%20bokeh%20effect%2C%20cinematic%20portrait&width=400&height=560&seq=card-trap-04&orientation=portrait',
  },
  {
    title: '《犬夜叉·高清重制》',
    description: '穿越五百年的命运之恋，半妖少年与现代少女的冒险物语，不朽经典高清再现。',
    tag: '日漫·经典',
    status: '已完结',
    heat: '9.9',
    image: 'https://readdy.ai/api/search-image?query=Japanese%20classic%20manga%20style%20fantasy%20warrior%20with%20silver%20hair%20and%20red%20robe%2C%20dynamic%20action%20pose%2C%20feudal%20Japan%20setting%2C%20warm%20sunset%20background%2C%20nostalgic%2080s%20anime%20aesthetic&width=400&height=560&seq=card-inuyasha-05&orientation=portrait',
  },
  {
    title: '《总裁的替身前妻》',
    description: '她只是姐姐的替身，却在新婚夜被识破。当真相揭开，霸道总裁却再也放不开她的手。',
    tag: '国漫·言情',
    status: '连载中',
    heat: '9.3',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20modern%20romance%2C%20elegant%20woman%20in%20luxury%20evening%20dress%2C%20wealthy%20interior%20background%2C%20warm%20chandelier%20lighting%2C%20dramatic%20composition%2C%20soft%20coral%20and%20gold%20color%20palette&width=400&height=560&seq=card-ceo-06&orientation=portrait',
  },
  {
    title: '《异世界食堂》',
    description: '平凡餐厅的后门连接着异世界，每周六，来自不同种族的客人们都会如约而至。',
    tag: '日漫·美食',
    status: '连载中',
    heat: '9.6',
    image: 'https://readdy.ai/api/search-image?query=Japanese%20manga%20food%20fantasy%20illustration%2C%20cozy%20western%20restaurant%20interior%20with%20warm%20lighting%2C%20delicious%20dishes%20on%20table%2C%20fantasy%20characters%20dining%2C%20steam%20and%20aroma%20atmosphere%2C%20comforting%20amber%20tones&width=400&height=560&seq=card-isekai-07&orientation=portrait',
  },
];

export const mockRankingItems = [
  { rank: 1, title: '社内恋爱法则', type: '韩漫', heat: '9.7', trend: 'up', views: '1,286万' },
  { rank: 2, title: '第七个夜晚', type: '日漫', heat: '9.8', trend: 'up', views: '1,154万' },
  { rank: 3, title: '剑道至尊', type: '国漫', heat: '9.5', trend: 'up', views: '1,093万' },
  { rank: 4, title: '犬夜叉·高清重制', type: '日漫', heat: '9.9', trend: 'stable', views: '987万' },
  { rank: 5, title: '甜蜜陷阱', type: '韩漫', heat: '9.4', trend: 'up', views: '912万' },
  { rank: 6, title: '异世界食堂', type: '日漫', heat: '9.6', trend: 'down', views: '876万' },
];

export const mockUpdates = [
  { date: '2024-07-29', title: '《社内恋爱法则》第87话更新', description: '林小晚的秘密被总裁发现了！两人关系即将迎来重大转折……', tag: '最新更新' },
  { date: '2024-07-28', title: '《剑道至尊》第156话更新', description: '剑灵觉醒，上古秘法重现人间，叶凡的实力再次突破极限。', tag: '最新更新' },
  { date: '2024-07-28', title: '新作上线：《深渊之下》', description: '人气作家"墨渊"全新悬疑力作，开篇即高能，烧脑程度拉满。', tag: '新作首发' },
  { date: '2024-07-27', title: '《甜蜜陷阱》第43话更新', description: '真相浮出水面，她终于看清了男友的真面目，复仇计划悄然启动。', tag: '最新更新' },
  { date: '2024-07-27', title: '暑期专题：百部完结韩漫免费开放', description: '暑假限时福利，平台精选100部高分完结韩漫全部免费开放阅读。', tag: '活动公告' },
  { date: '2024-07-26', title: '《异世界食堂》第62话更新', description: '新的异世界客人到访，这次带来的是一道传说中的禁忌料理。', tag: '最新更新' },
  { date: '2024-07-25', title: '平台升级：阅读器全面优化', description: '新版阅读器上线，加载速度提升40%，新增夜间模式和自动书签功能。', tag: '系统公告' },
  { date: '2024-07-24', title: '《第七个夜晚》番外篇上线', description: '完结撒花！作者特别绘制番外短篇，揭开正篇中未解答的谜团。', tag: '番外特别' },
];

export const mockFaqItems = [
  {
    question: '羞羞漫画是免费的吗？',
    answer: '是的，羞羞漫画平台上的所有漫画作品均为免费阅读，无需付费订阅或购买会员。我们坚持"免费、高清、极速"的服务理念，让每一位漫画爱好者都能零门槛畅享阅读乐趣。部分合作作品会有少量广告以支持运营，但不会影响正常阅读体验。',
  },
  {
    question: '什么是下拉式阅读模式？',
    answer: '下拉式阅读是羞羞漫画独创的阅读方式，区别于传统的左右翻页，你只需像刷朋友圈一样上下滑动屏幕即可流畅阅读。这种模式特别适合手机端单手操作，通勤、排队等碎片时间也能轻松追漫。你可以在阅读器设置中随时切换下拉式或翻页式两种模式。',
  },
  {
    question: '漫画更新频率是怎样的？',
    answer: '热门连载作品通常每周更新1-2话，与韩国、日本、国内原创平台保持同步。当你有追更的作品时，系统会在新章节上线后第一时间推送更新提醒。你可以在"我的书架"中管理追更列表，随时查看所有正在追的作品更新状态。',
  },
  {
    question: '支持哪些设备阅读？',
    answer: '羞羞漫画完美适配手机、平板和电脑端。我们提供网页版（手机浏览器直接访问）、iOS客户端和Android客户端三种方式。移动端支持离线下载功能，提前缓存喜欢的漫画，即使没有网络也能随时阅读。所有设备间的阅读进度、书架收藏会自动同步。',
  },
];

export const mockContact = {
  title: '联系我们',
  description: '如有版权合作、内容投稿、广告商务或其他问题，欢迎通过以下方式与我们取得联系。我们的运营团队将在1-2个工作日内回复。',
  email: 'contact@xiuxiumanhua.com',
  wechat: 'xiuxiuxiu_comic',
  qq: '2850174823',
};

export const mockApp = {
  title: '羞羞漫画 App',
  description: '扫码下载羞羞漫画移动客户端，享受更流畅的下拉式阅读体验，支持离线下载、夜间模式和推送提醒。',
  iosVersion: 'v4.8.2',
  androidVersion: 'v4.8.2',
  size: '38.6 MB',
};

export const mockTopics = [
  { name: '韩漫推荐', heat: '1,286万', color: 'primary' },
  { name: '恋爱漫画', heat: '1,154万', color: 'accent' },
  { name: '悬疑推理', heat: '987万', color: 'secondary' },
  { name: '日漫经典', heat: '943万', color: 'primary' },
  { name: '国漫崛起', heat: '876万', color: 'accent' },
  { name: '完结推荐', heat: '765万', color: 'secondary' },
  { name: '少女漫画', heat: '698万', color: 'primary' },
  { name: '奇幻冒险', heat: '654万', color: 'accent' },
  { name: 'BL漫画', heat: '589万', color: 'secondary' },
  { name: '新作速递', heat: '543万', color: 'primary' },
  { name: '漫改动画', heat: '498万', color: 'accent' },
];

export const mockComments = [
  {
    name: '漫画控小樱',
    avatar: 'https://readdy.ai/api/search-image?query=Anime%20style%20girl%20avatar%20portrait%2C%20pink%20hair%2C%20cute%20expression%2C%20simple%20warm%20background%2C%20clean%20illustration&width=80&height=80&seq=avatar-sakura&orientation=squarish',
    date: '2024-07-28',
    content: '真的太爱羞羞漫画了！下拉式阅读太方便了，上班摸鱼的时候单手就能看。而且更新速度真的快，韩漫几乎和韩国同步，再也不用到处找资源了。推荐《社内恋爱法则》，男主太帅了呜呜呜！',
    rating: 5,
  },
  {
    name: '热血阿杰',
    avatar: 'https://readdy.ai/api/search-image?query=Anime%20style%20boy%20avatar%20portrait%2C%20short%20dark%20hair%2C%20confident%20smile%2C%20simple%20warm%20background%2C%20clean%20illustration&width=80&height=80&seq=avatar-jay&orientation=squarish',
    date: '2024-07-26',
    content: '作为一个看了十几年漫画的老读者，说实话这个平台真的良心。不仅免费，画质也高，而且没有那种弹窗广告。最近在追《剑道至尊》，每周期待更新已经成了固定节目。唯一建议是希望能增加评论区功能。',
    rating: 4,
  },
  {
    name: '深夜追漫人',
    avatar: 'https://readdy.ai/api/search-image?query=Anime%20style%20character%20avatar%20portrait%2C%20glasses%2C%20gentle%20smile%2C%20cozy%20night%20atmosphere%2C%20simple%20background%2C%20clean%20illustration&width=80&height=80&seq=avatar-night&orientation=squarish',
    date: '2024-07-25',
    content: '从贴吧看到推荐过来的，用了三个月了，真的很不错。日漫资源很全，连一些老番的高清重制版都有。最近在看《犬夜叉》重制，画质提升太明显了！而且离线下载功能真的很实用，地铁上没信号也能看。',
    rating: 5,
  },
];

export const mockMediaItems = [
  {
    title: '国漫《剑道至尊》动画化PV首发',
    description: '万众期待的《剑道至尊》动画化正式官宣！首支PV曝光，画风和战斗场面令人惊艳。',
    views: '1,286万',
    type: '预告片',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20animation%20style%20action%20scene%2C%20sword%20fighter%20with%20dramatic%20energy%20effects%2C%20golden%20and%20coral%20color%20palette%2C%20dynamic%20composition%2C%20epic%20cinematic%20lighting%2C%20clean%20background&width=720&height=400&seq=media-pv-01&orientation=landscape',
  },
  {
    title: '韩漫恋爱经典场景混剪合集',
    description: '从《社内恋爱法则》到《甜蜜陷阱》，那些让人心跳加速的名场面一次看过瘾。',
    views: '1,098万',
    type: '混剪',
    image: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20romantic%20scenes%20collage%20style%2C%20multiple%20couple%20silhouettes%20with%20soft%20bokeh%2C%20warm%20peach%20and%20pink%20atmosphere%2C%20dreamy%20lighting%2C%20romantic%20ambiance&width=720&height=400&seq=media-rom-02&orientation=landscape',
  },
  {
    title: '漫画家访谈：墨渊谈《深渊之下》',
    description: '人气悬疑作家墨渊首次出镜，分享《深渊之下》的创作灵感和背后不为人知的故事。',
    views: '765万',
    type: '访谈',
    image: 'https://readdy.ai/api/search-image?query=Artist%20studio%20interview%20setting%2C%20drawing%20table%20with%20manga%20tools%2C%20warm%20ambient%20lighting%2C%20creative%20workspace%2C%20cozy%20atmosphere%2C%20artistic%20environment&width=720&height=400&seq=media-interview-03&orientation=landscape',
  },
  {
    title: '《第七个夜晚》完结纪念特辑',
    description: '陪伴读者两年的悬疑神作圆满落幕！回顾全篇高能时刻，粉丝纷纷泪目告别。',
    views: '654万',
    type: '特辑',
    image: 'https://readdy.ai/api/search-image?query=Japanese%20manga%20ending%20illustration%20style%2C%20sunset%20silhouette%20with%20nostalgic%20warm%20tones%2C%20emotional%20farewell%20scene%2C%20amber%20and%20coral%20gradient%20sky%2C%20bittersweet%20atmosphere&width=720&height=400&seq=media-ending-04&orientation=landscape',
  },
  {
    title: '2024年度漫画大赏提名作品巡礼',
    description: '年度漫画大赏提名名单正式公布！来看看今年有哪些作品入围各大奖项。',
    views: '543万',
    type: '盘点',
    image: 'https://readdy.ai/api/search-image?query=Award%20ceremony%20style%20presentation%2C%20elegant%20spotlight%20with%20red%20carpet%20theme%2C%20warm%20golden%20and%20coral%20lighting%2C%20prestigious%20atmosphere%2C%20clean%20composition%20with%20trophy%20elements&width=720&height=400&seq=media-awards-05&orientation=landscape',
  },
];